<template>
  <header id="site-header" class="site-header" :class="{ 'open' : isOpen }">
    <div class="flex content-max-width">
      <a href="/home" class="logo">
        <img :src="`/images/${isOpen ? 'logo-dark.jpg' : 'logo.png'}`" alt="Glasslines" />
      </a>

      <nav>
        <ul class="top">
          <!-- <li><a href="">Careers</a></li>
          <li><a href="">Lifestyle</a></li>
          <li><a href="">About Us</a></li> -->
          <li class="mobile"><a href="/">Home</a></li>
          <li v-for="(link, index) of navigation" :key="index">
            <a :href="link.url">{{ link.title }}</a>
          </li>
          <li><a href="https://www.glasslines.co.nz/about-us" target="_blank">About Us</a></li>
          <li v-if="logged_in">
            <app-logout-link :csrf="csrf"></app-logout-link>
          </li>
        </ul>
        <div class="flex social mobile">
          <img src="/images/icons/fb.svg" alt="">
          <img src="/images/icons/ig.svg" alt="">
        </div>
      </nav>
      <a href="tel:09-489 6263" class="tel">{{ content.phone }}</a>
      <a href="mailto:careers@glasslines.co.nz" class="email">{{ content.email_to}}</a>

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf','navigation', 'logged_in', 'content'
  ],  
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    
    toggleMenu() {
      this.isOpen = !this.isOpen;
    },
    
    logout() {
      window.axios.post('/logout', { token: this.csrf })
        .then(response => {
          window.location.href= '/'
        })
        .catch(error => {
          
        })
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue